const MerchandiseRack = {

    // FIELDS
    "customer": "Customer",
    "rack": "Rack",
    "name": "Name",
    "search": "Search",

    // PAGE HEADER
    "merchant_rack": "Merchandise Rack",

    // ERROR
    "error_customer": "Select Customer",
    "error_name": "Enter Name",

    // TABLE HEADER
    "table_customer": 'CUSTOMER',
    "table_grade": 'GRADE',
    "table_type": 'TYPE',
    "table_city": 'CITY',
    "table_category": 'CATEGORY',
}

export default MerchandiseRack;